import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';
import { requireReleaseFlag } from '@/entities/session/lib/releaseGuard';
import { ProjectDetailMemoPage } from '@/pages/projects/ui/ProjectDetailMemoPage';
import { routeValidateQuerySearch } from '@/shared/lib/route';

const querySchema = z.object({
  /** AIチャットのスレッドID（事業詳細と共通の AI パネルで使用） */
  threadId: z.string().optional(),
  /** 現在開いているメモID（リロード時に状態復元するため URL に反映） */
  memoId: z.string().optional(),
});

export const Route = createFileRoute('/_protected/projects/$projectId/memo')({
  component: ProjectDetailMemoPage,
  beforeLoad: () => {
    requireReleaseFlag('memo');
  },
  validateSearch: (record) =>
    routeValidateQuerySearch({
      record,
      usePaginationSchema: false,
      customSchema: querySchema,
      defaultValues: {},
    }),
});
